import gql from 'graphql-tag'
import { get } from 'lodash'
import { IUser } from '../../../types/User'
import { apolloClientPrivate } from '../graphql/apolloClient'

export interface IVariables {
  filterUsers: any
}
// TODO move into a gql file and use the generated query
export default async (variables: IVariables): Promise<IUser[]> => {
  const query = gql`
    query listUsers($filterUsers: [FilterDescriptor!]) {
      users(filters: $filterUsers) {
        id
        userIdentity
        display_name
        image_url
      }
    }
  `

  const response = await apolloClientPrivate.query({
    variables,
    query
  })

  return get(response, 'data.users')
}
